import { ActionTimestamp } from "../../../action";
import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";

export const Collect3005 = (actionId: string, state: State) => {
  const newBricks = new Map(state.bricks);
  const newActions = new Map(state.actions);
  const newActionTimestamps = state.actionTimestamps;
  const newBricksCollectedByType = state.bricksCollectedByType;
  const newActionsTriggeredByType = state.actionsTriggeredByType;

  let brick_3005 = newBricks.get("3005")!;
  const action = new Map(state.actions).get(actionId)!;

  // Update amount if set to default NaN
  if (Number.isNaN(brick_3005.amount)) brick_3005.amount = 0;

  // Max Capacity reached
  if (brick_3005.amount === brick_3005.capacity) return state;

  // Apply Costs
  // N/A

  // Apply Outcomes
  brick_3005.amount++;

  // Apply Action Visibility
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Increase in costScale
  // N/A

  // Add ActionTimestamp
  const timestamp: ActionTimestamp = {
    id: brick_3005.id,
    amount: 1,
    timestamp: Date.now(),
  };

  newActionTimestamps.push(timestamp);

  // Apply Achievement Data
  const newBricksAmt = newBricksCollectedByType.get("3005") ?? 0;
  newBricksCollectedByType.set("3005", newBricksAmt + 1);

  const newActionsAmt = newActionsTriggeredByType.get(actionId) ?? 0;
  newActionsTriggeredByType.set(actionId, newActionsAmt + 1);

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: newBricks,
    actions: updatedActions,
    actionOrder: newActionOrder,
    totalBricksCollected: state.totalBricksCollected + 1,
    totalActionsTriggered: state.totalActionsTriggered + 1,
    bricksCollectedByType: newBricksCollectedByType,
    actionsTriggeredByType: newActionsTriggeredByType,
  };

  return applyAchievementChecks(newState);
};
